"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alzano-lombardo": {
    "c0c97ae8": [{
      "hkey": "c95782a5",
      "slug": "alzano-lombardo-paese",
      "name": "Alzano Lombardo paese",
      "primary": true,
      "skipSearch": false
    }],
    "nese": [{
      "hkey": "c95782a5",
      "slug": "alzano-lombardo-paese",
      "name": "Alzano Lombardo paese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;